import { render, staticRenderFns } from "./bidDocx.vue?vue&type=template&id=d84bb6d8&"
import script from "./bidDocx.vue?vue&type=script&lang=js&"
export * from "./bidDocx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports